import * as Yup from 'yup';

// Bahraini phone number validation
// Format: +973 XXXX XXXX (8 digits after country code)
const bahrainiPhoneRegex = /^\+973[0-9]{8}$/;

export const validateBahrainiPhone = (phone: string | undefined | null): boolean => {
  if (!phone) return true; // Optional field
  const cleanPhone = phone.replace(/\s+/g, '');
  return bahrainiPhoneRegex.test(cleanPhone);
};

export const registerValidationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must not exceed 50 characters'),
  last_name: Yup.string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must not exceed 50 characters'),
  business_name: Yup.string()
    .required('Business name is required')
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must not exceed 100 characters'),
  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: Yup.string()
    .required('Please confirm your password')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
  phoneNumber: Yup.string().nullable(),
  role: Yup.string(),
  store_id: Yup.string(),
  is_store_owner: Yup.boolean(),
  is_super_admin: Yup.boolean(),
  permissions: Yup.array().of(Yup.string())
}); 